/**
 * Verification Service Mappers
 *
 * Maps snake_case API responses to camelCase domain types.
 */

import {
  VerificationSession,
  VerificationUnit,
  VerificationItem,
} from '../types/verification';

export const mapItem = (raw: any): VerificationItem => ({
  id: raw.id,
  sessionId: raw.session_id,
  unitId: raw.unit_id,
  sortOrder: raw.sort_order,
  specification: raw.specification || '',
  itemName: raw.item_name || '',
  classifications: raw.classifications || [],
  standardTarget: raw.standard_target || '',
  verificationMethodsPrimary: raw.verification_methods_primary || [],
  verificationMethodsSecondary: raw.verification_methods_secondary || [],
  qualityRecordNo: raw.quality_record_no || '',
  qualityRecordTitle: raw.quality_record_title || '',
  reviewJudgment: raw.review_judgment,
  qualityRecordNoRight: raw.quality_record_no_right || '',
  qualityRecordTitleRight: raw.quality_record_title_right || '',
  sourceDrbfmSessionId: raw.source_drbfm_session_id,
  sourceFailureModeId: raw.source_failure_mode_id,
  createdAt: raw.created_at,
  updatedAt: raw.updated_at,
});

export const mapUnit = (raw: any): VerificationUnit => ({
  id: raw.id,
  sessionId: raw.session_id,
  unitNumber: raw.unit_number || '',
  unitName: raw.unit_name || '',
  sortOrder: raw.sort_order,
  items: (raw.items || []).map(mapItem),
  createdAt: raw.created_at,
});

export const mapSession = (raw: any): VerificationSession => ({
  id: raw.id,
  tenantId: raw.tenant_id,
  userId: raw.user_id,
  title: raw.title,
  modelName: raw.model_name,
  description: raw.description,
  units: (raw.units || []).map(mapUnit),
  createdAt: raw.created_at,
  updatedAt: raw.updated_at,
});
